import React, { useState } from 'react';

import PlaidIntro from './PlaidIntro';
import SendByPlaid from './SendByPlaid';

const MainPlaidModal = (props) => {
    const [isShowModal, setShowModal] = useState(props.isShowModal);

    return isShowModal ? <PlaidIntro onClick={() => setShowModal(false)} /> : <SendByPlaid onSuccess={props.onSuccess} />;
};
export default MainPlaidModal;
